export default {
  all (context) {
    context.loading = true
    context.$http.get('catalogs').then(response => {
      context.loading = false
      context.catalogs = response.body.data
    })
  },
  get (context, id) {
    context.$http.get('catalogs/' + id).then(response => {
      context.catalog = response.body.data[0]
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/catalogs.js